class Drug {
  constructor(
    title,
    code,
    dosageNoteForLessThan11,
    dosageNoteForMoreThan11,
    contraindication,
    drugGroupId,
    unitId,
    orderTypeIds,
  ) {
    this.title = title;
    this.code = code;
    this.dosageNoteForLessThan11 = dosageNoteForLessThan11;
    this.dosageNoteForMoreThan11 = dosageNoteForMoreThan11;
    this.contraindication = contraindication;
    this.drugGroupId = drugGroupId;
    this.unitId = unitId;
    this.orderTypeIds = orderTypeIds;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allDrugs: [],
      allDrugsForOther: [],
      drug: new Drug('', '', '', '', '', null, null, null),
      drugPaginationList: [],
    };
  },
  methods: {
    getListOfDrugsWithGroupId: function (groupId) {
      this.load.val = true;
      this.$store
        .dispatch('getAllDrugsWithGroupId', groupId)
        .then(() => {
          if (this.$store.state.drugModule.successFlag) {
            this.allDrugs = this.$store.state.drugModule.allDrugs;
          } else {
            if (this.$store.state.drugModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfDrugsWithGroupId(groupId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.drugModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfDrugsWithGroupId(groupId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    getListOfDrugsForOtherWithGroupId: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllDrugsWithGroupId', id).then(() => {
        if (this.$store.state.drugModule.successFlag) {
          this.allDrugsForOther = this.$store.state.drugModule.allDrugs;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.drugModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfDrugsForOtherWithGroupId(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.drugModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfDrugsForOtherWithGroupId(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfDrugsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllDrugs').then(() => {
        if (this.$store.state.drugModule.successFlag) {
          this.allDrugsForOther = this.$store.state.drugModule.allDrugs;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.drugModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfDrugsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.drugModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfDrugsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllDrugs: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllDrugs').then(() => {
        if (this.$store.state.drugModule.successFlag) {
          this.allDrugs = this.$store.state.drugModule.allDrugs;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.drugModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllDrugs();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.drugModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllDrugs();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfDrugsWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getDrugsWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          title: this.searchText,
          code: this.searchCode,
          drugGroupId: this.searchDrugGroupId,
          unitId: this.searchUnitId,
        })
        .then(() => {
          if (this.$store.state.drugModule.successFlag) {
            this.drugPaginationList = [];
            let temp = this.$store.state.drugModule.drugs;
            for (let i = 0; i < temp.length; i++) {
              let orderType = '';
              for (let j = 0; j < temp[i].orderTypes.length; j++) {
                orderType += temp[i].orderTypes[j].title + ',';
              }
              orderType = this.removeLastCharechter(orderType);
              this.drugPaginationList.push({
                counter: i + 1,
                title: temp[i].title ? temp[i].title : '-',
                code: temp[i].code ? temp[i].code : '-',
                group: temp[i].drugGroup ? temp[i].drugGroup.title : '-',
                unit: temp[i].unit ? temp[i].unit.title : '-',
                orderType: orderType,
                id: temp[i].id,
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.drugModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.drugModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.drugModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.drugModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfDrugsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.drugModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfDrugsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    addDrugFunction: function () {
      if (!this.drug.title) {
        this.snackText = 'عنوان دارو نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.drug.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان دارو نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.drug.drugGroupId) {
        this.snackText = 'گروه دارو نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.drug.unitId) {
        this.snackText = 'واحد دارو نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.drug.orderTypeIds) {
        this.snackText = 'نحوه تجویز دارو نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addDrug', this.drug).then(() => {
        if (this.$store.state.drugModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' دارو با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.drug = new Drug('', '', '', '', '', null, null, null);
          this.$router.push({ name: 'drug' });
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.drugModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addDrugFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.drugModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addDrugFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getDrugFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDrug', id).then(() => {
        if (this.$store.state.drugModule.successFlag) {
          let temp = this.$store.state.drugModule.drug;
          this.drug.id = temp.id;
          this.drug.title = temp.title;
          this.drug.dosageNoteForLessThan11 = temp.dosageNoteForLessThan11;
          this.drug.dosageNoteForMoreThan11 = temp.dosageNoteForMoreThan11;
          this.drug.contraindication = temp.contraindication;
          this.drug.code = temp.code;
          this.drug.drugGroupId = temp.drugGroup.id;
          this.drug.unitId = temp.unit.id;
          this.drug.orderTypeIds = [];
          for (let i = 0; i < temp.orderTypes.length; i++) {
            this.drug.orderTypeIds.push(Number(temp.orderTypes[i].orderTypeId));
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.drugModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getDrugFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.drugModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getDrugFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editDrugFunction: function () {
      if (!this.drug.title) {
        this.snackText = 'عنوان دارو نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.drug.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان دارو نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.drug.drugGroupId) {
        this.snackText = 'گروه دارو نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.drug.unitId) {
        this.snackText = 'واحد دارو نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.drug.orderTypeIds) {
        this.snackText = 'نحوه تجویز دارو نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editDrug', this.drug).then(() => {
        if (this.$store.state.drugModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = ' دارو با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.drug = new Drug('', '', '', '', '', null, null, null);
          this.$router.push({ name: 'drug' });
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.drugModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editDrugFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.drugModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editDrugFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getDrugDetailFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDrugDetail', id).then(() => {
        if (this.$store.state.drugModule.successFlag) {
          this.drugDetail = this.$store.state.drugModule.drugDetail;
          if (this.$route.name == 'drugMoreInformation') {
            this.makeDataReady(this.drugDetail);
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.drugModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getDrugDetailFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.drugModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getDrugDetailFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteDrugFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteDrug', this.drugId).then(() => {
        if (this.$store.state.drugModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfDrugsWithPagination();
          this.snackText = ' دارو با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.drugModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteDrugFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.drugModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteDrugFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.drugModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
